import { ColorAccessory } from './ColorAccessory';

export class Model {
  id?: number;
  name?: string;
  picture?: string;
  lstColor?: ColorAccessory[];
  selectedColorName?: string;
  selected?: boolean;
  gamme?: string;
  isGamme?: boolean;
  serie?: string;
  isSerie?: boolean;
  isPrev?: boolean;
  isVisible?: boolean = true;
  dateDeb?: string;
  dateFin?: string;
}
